import * as angular from "angular";

export class NotificationService {
    private readonly apiRoot: string;
    private readonly $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = __env.apiUrl() + "/notification";
    }

    all(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/all", data);
    }

    count(): Promise<object> {
        return this.$http.get(this.apiRoot + "/count");
    }

    countIssues(): Promise<object> {
        return this.$http.get(this.apiRoot + "/issues");
    }

    setSeen(data: any): Promise<object> {
        return this.$http.post(
            this.apiRoot + "/seen/" + data.notificationid,
            data
        );
    }

    settings(): Promise<object> {
        return this.$http.get(this.apiRoot + "/settings");
    }

    updateSettings(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/settings", data);
    }

    setAllSeen(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/allseen", data);
    }

    setIssuesSeen(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/issuesseen", data);
    }
}

angular
    .module("vcServices")
    .service("NotificationService", NotificationService);
